var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "details-view" }, [
        _c("div", { staticStyle: { height: "100%" } }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-wrap": "nowrap",
                height: "100%"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "25%", "background-color": "#ffffff" }
                },
                [
                  _c("div", { staticStyle: { "margin-top": "4px" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          padding: "2px",
                          "background-color": "#169bd5",
                          cursor: "pointer",
                          color: "#169bd5"
                        }
                      },
                      [_vm._v(_vm._s("."))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_ScenarioSettings"))
                        )
                      ]
                    )
                  ]),
                  _c("cargo-ag-grid", {
                    staticStyle: { width: "100%", "margin-top": "12px" },
                    attrs: {
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData,
                      "grid-options": _vm.gridOptions
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: {
                    width: "35%",
                    "background-color": "#ffffff",
                    position: "relative"
                  }
                },
                [
                  _c("div", { staticStyle: { "margin-top": "4px" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          padding: "2px",
                          "background-color": "#169bd5",
                          cursor: "pointer",
                          color: "#169bd5"
                        }
                      },
                      [_vm._v(_vm._s("."))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("CargoMsg.Cargo_ScenarioDescription"))
                        )
                      ]
                    )
                  ]),
                  _vm.showVoiceButton
                    ? _c(
                        "el-button",
                        {
                          staticClass: "voice-btn-corner",
                          class: {
                            recording: _vm.voiceRecognition.isRecording
                          },
                          attrs: {
                            type: _vm.voiceRecognition.isRecording
                              ? "danger"
                              : "default",
                            disabled: _vm.voiceButtonDisabled,
                            size: "mini"
                          },
                          on: { click: _vm.handleVoiceButtonClick }
                        },
                        [
                          _c("span", { staticClass: "voice-btn-content" }, [
                            _vm.voiceRecognition.isProcessing
                              ? _c("i", {
                                  staticClass: "el-icon-loading custom-loading"
                                })
                              : _c("i", { class: _vm.voiceButtonIcon }),
                            _c("span", { staticClass: "btn-text" }, [
                              _vm._v(_vm._s(_vm.voiceButtonText))
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        height: "100%",
                        "margin-top": "12px"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { height: "100%", width: "82%" } },
                        [
                          _c(
                            "el-form",
                            {
                              staticStyle: { height: "100%" },
                              attrs: {
                                "label-position": "left",
                                "label-width": "0px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticClass: "input-from",
                                  staticStyle: { height: "100%" },
                                  attrs: { label: " " }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "textarea-container" },
                                    [
                                      _c("el-input", {
                                        staticClass: "input-border",
                                        attrs: {
                                          "filter-chars": false,
                                          type: "textarea",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.task.dataMessage,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.task,
                                              "dataMessage",
                                              $$v
                                            )
                                          },
                                          expression: "task.dataMessage"
                                        }
                                      }),
                                      _vm.voiceRecognition.isRecording
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "voice-recording-indicator-inner"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-microphone voice-icon"
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "loading-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_VoiceRecording",
                                                        [
                                                          _vm.voiceRecognition
                                                            .remainingTime
                                                        ]
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "voice-wave" },
                                                [
                                                  _c("span", {
                                                    staticClass: "wave-bar"
                                                  }),
                                                  _c("span", {
                                                    staticClass: "wave-bar"
                                                  }),
                                                  _c("span", {
                                                    staticClass: "wave-bar"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "18%", "padding-top": "20%" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "row",
                                "align-content": "stretch",
                                "align-items": "stretch",
                                "justify-content": "center"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.generateScript }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_GenerateScript") +
                                        " >>"
                                    ) + " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "section",
                  staticStyle: { width: "40%", "background-color": "#ffffff" }
                },
                [
                  _c("div", { staticStyle: { "margin-top": "4px" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "absolute",
                          padding: "2px",
                          "background-color": "#169bd5",
                          cursor: "pointer",
                          color: "#169bd5"
                        }
                      },
                      [_vm._v(_vm._s("."))]
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "padding-left": "10px",
                          "padding-bottom": "5px"
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_DataScript"))
                        )
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    { staticStyle: { height: "50%", "margin-top": "12px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "input-from",
                              staticStyle: { height: "100%" },
                              attrs: { label: " " }
                            },
                            [
                              _c("el-input", {
                                staticClass: "input-border",
                                attrs: {
                                  disabled: !_vm.isPlatform,
                                  "filter-chars": false,
                                  type: "textarea",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.task.dataScript,
                                  callback: function($$v) {
                                    _vm.$set(_vm.task, "dataScript", $$v)
                                  },
                                  expression: "task.dataScript"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "padding-top": "5px",
                        "padding-bottom": "5px",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                position: "absolute",
                                padding: "2px",
                                "background-color": "#169bd5",
                                cursor: "pointer",
                                color: "#169bd5"
                              }
                            },
                            [_vm._v(_vm._s("."))]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "padding-left": "10px",
                                display: "flex"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_DataDisplay")) +
                                  " "
                              )
                            ]
                          )
                        ]
                      ),
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _vm.form.taskScenario ===
                            _vm.SystemConstants.TASK_SCENARIO_3.code ||
                          _vm.form.taskScenario ===
                            _vm.SystemConstants.TASK_SCENARIO_4.code ||
                          _vm.form.taskScenario ===
                            _vm.SystemConstants.TASK_SCENARIO_5.code
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    margin: "8px 12px 0 0",
                                    color: "#169bd5"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_TotalDataCount", [
                                        _vm.rowsTotal
                                      ])
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "success" },
                              on: { click: _vm.previewDataHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_PreviewData"))
                              )
                            ]
                          ),
                          _vm.form.taskScenario ===
                          _vm.SystemConstants.TASK_SCENARIO_1.code
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.debugExecuteHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_DebugExecute")
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticStyle: { height: "50%", "margin-top": "12px" } },
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: { height: "100%" },
                          attrs: {
                            "label-position": "left",
                            "label-width": "0px"
                          }
                        },
                        [
                          _c("cargo-ag-grid", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: {
                              "column-defs": _vm.previewColumnDefs,
                              "row-data": _vm.previewData.rowData,
                              "grid-options": _vm.previewData.gridOptions
                            },
                            on: {
                              gridReady: function(params) {
                                _vm.previewData.gridApi = params.api
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ])
      ]),
      _vm.form.taskScenario === _vm.SystemConstants.TASK_SCENARIO_1.code &&
      _vm.makeInvoiceDialog.visible
        ? _c("invoice-detail-dialog", {
            ref: "makeInvoiceDialog",
            attrs: {
              visible: _vm.makeInvoiceDialog.visible,
              title: _vm.$t("Invoice.invoice_invoiceInformation"),
              params: _vm.makeInvoiceDialog.params,
              properties: _vm.properties,
              location: _vm.location,
              "look-view": true,
              "view-source": "tabInvoiceQuery"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.makeInvoiceDialog, "visible", $event)
              },
              toStepHandler: _vm.toStepHandler,
              pageChange: _vm.pageChange
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }